export default {
    '哪吒爱动智慧体育平台':'哪吒爱动智慧体育平台',
    '登录鉴权中':'登录鉴权中，请稍候...',
    '登录':'登录',
    '爱动力科技':'爱动力科技',
    '退出登录':'退出登录',
    '个人中心':'个人中心',
    '简体中文':'简体中文',
    '繁體中文':'繁體中文',
    '英语':'English',
    // 2025.3.19
    '新密码':'新密码',
    '请输入新密码':'请输入新密码',
    '确认新密码':'确认新密码',
    '请再次输入新密码以确认':'请再次输入新密码以确认',
    '新密码不能少于8位':'新密码不能少于8位',
    '请填写新密码':'请填写新密码',
    '账号密码格式仅支持大小写字母、数字及特殊符号':'账号密码格式仅支持大小写字母、数字及特殊符号',
    '新密码不能多于20位':'新密码不能多于20位',
    '请确认新密码':'请确认新密码',
    '新账号密码长度至少为8位':'新账号密码长度至少为8位',
    '确认密码与新密码不一致!':'确认密码与新密码不一致!',
    '重置密码成功':'重置密码成功',

    // 2025.12.19
    '密码至少8位，需要包含英文+数字':'密码至少8位，需要包含英文+数字',
}